import { render } from "./RegistMinute.vue?vue&type=template&id=00c13ea2&scoped=true"
import script from "./RegistMinute.vue?vue&type=script&lang=js"
export * from "./RegistMinute.vue?vue&type=script&lang=js"

import "./RegistMinute.vue?vue&type=style&index=0&id=00c13ea2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-00c13ea2"

export default script